import React from 'react';
import { MarketSvgProps } from '../market-icons';

const GiftCardIcon: React.FC<MarketSvgProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8613 1.10685C14.7734 0.850088 15.6903 1.06764 16.3115 1.68888C16.9327 2.31012 17.1503 3.22702 16.8936 4.13908C16.8069 4.44686 16.6693 4.73705 16.4922 5.0004H19.5C21.1568 5.0004 22.4999 6.34361 22.5 8.0004V18.0004C22.5 19.6572 21.1568 21.0004 19.5 21.0004H4.5C2.84317 21.0004 1.50004 19.6572 1.5 18.0004V8.0004C1.50007 6.34361 2.84319 5.0004 4.5 5.0004H7.50781C7.33071 4.73705 7.19312 4.44686 7.10645 4.13908C6.84969 3.22702 7.06726 2.31012 7.68848 1.68888C8.30972 1.06764 9.2266 0.850088 10.1387 1.10685C10.9303 1.32978 11.6072 1.88576 12 2.60197C12.3928 1.88576 13.0697 1.32978 13.8613 1.10685ZM3.66406 14.7475C3.61255 14.7933 3.55739 14.8324 3.5 14.8656V18.0004C3.50004 18.5527 3.94774 19.0004 4.5 19.0004H11.6201L20.3359 11.2533C20.3876 11.2074 20.4425 11.1675 20.5 11.1342V8.0004C20.4999 7.44818 20.0522 7.0004 19.5 7.0004H12.3799L3.66406 14.7475ZM14.6299 19.0004H19.5C20.0523 19.0004 20.5 18.5527 20.5 18.0004V13.7817L14.6299 19.0004ZM4.5 7.0004C3.94776 7.0004 3.50007 7.44818 3.5 8.0004V12.2182L9.37012 7.0004H4.5ZM9.59668 3.03165C9.31739 2.95307 9.16694 3.03854 9.10254 3.10294C9.03814 3.16736 8.95268 3.31784 9.03125 3.59708C9.12671 3.93599 9.42769 4.237 9.7666 4.33243L10.5547 4.55411L10.332 3.767C10.2366 3.42808 9.93561 3.1271 9.59668 3.03165ZM14.8975 3.10294C14.8331 3.03854 14.6826 2.95307 14.4033 3.03165C14.0644 3.1271 13.7634 3.42808 13.668 3.767L13.4453 4.55411L14.2334 4.33243C14.5723 4.237 14.8733 3.93599 14.9688 3.59708C15.0473 3.31784 14.9619 3.16736 14.8975 3.10294Z"
        fill="#101010"
      />
    </svg>
  );
};

export default GiftCardIcon;
